<ng-template [bgAwaitPromises]="issuerIdParam">
	<!-- Embedded View -->
	<div class="l-cardembedded" *ngIf="embedService.isEmbedded">
		<div class="card card-largeimage">
			<a class="card-x-main" [href]="issuer.id" target="_blank">
				<div class="card-x-image">
					<img [loaded-src]="issuer.image || issuerImagePlaceholderUrl"
					     [loading-src]="badgeLoadingImageUrl"
					     [error-src]="badgeFailedImageUrl"
					     alt="Logo for issuer {{ issuer.name }}"
					     width="60" height="60" />
				</div>
				<div class="card-x-text">
					<h1>{{ issuer.name }}</h1>
					<small *ngIf="issuer.url"><a [href]="issuer.url">{{ issuer.url }}</a></small>
				</div>
			</a>
		</div>
	</div>

	<!-- Regular View -->
	<main *ngIf="! embedService.isEmbedded">
		<form-message></form-message>
		<header class="topbar topbar-withimage">
			<div class="l-containerxaxis issuer-public-banner">
				<div class="issuer-public-banner-image">
					<img [loaded-src]="issuer.image || issuerImagePlaceholderUrl"
					     [loading-src]="badgeLoadingImageUrl"
					     [error-src]="badgeFailedImageUrl"
					     alt="Logo for issuer {{ issuer.name }}"
					     class="topbar-x-image"
						 width="60" height="60" />
				</div>
				<div class="issuer-public-banner-text">
				    <h1 class="topbar-x-heading text-white">{{ issuer.name }}</h1>
					<div class="topbar-x-subheading">
						<p class="u-text-small-bold text-white">
							{{ issuer.email }}
						</p>
						<p class="u-margin-top1x u-width-paragraph text-white">
							{{ issuer.description }}</p>
						<div class="u-margin-top1x">
							<br/>
						</div>
						<bg-popup-menu #issuerVerified class="menu l-flex l-flex-column l-flex-2x menu-is-open verified-popup">
							<div class="l-grid l-grid-1 l-grid-1x" style="--cols: 1fr auto; align-items: stretch;">
								<div>
									<div class="l-flex l-flex-5x l-flex-justifybetween u-margin-bottom1x">
										<h2 class="u-text u-text-h3 u-text-dark3"> {{ 'earnedBadgeAndBadgeDetailPage.verifiedIssuer' | translate }} </h2>
										<img alt="Verified Issuer" class="emptysection-x-image verified-logo"
										[src]="verifiedSrc">
									</div>
								<ul class="u-text u-margin-bottom1x">
									<li>
										<strong class="u-text-dark3 u-text-bold">{{ 'earnedBadgeAndBadgeDetailPage.organization' | translate }}: </strong>
										<a class="u-text-link" style="font-size: inherit;" href="{{ issuer.id }}"> {{ issuer.name }} </a>
									</li>
									<li>
										<strong class="u-text-dark3 u-text-bold">{{ 'earnedBadgeAndBadgeDetailPage.issuer' | translate }}: {{ issuer.name }} </strong>
										<span class="u-text" style="font-size: inherit;">  </span>
									</li>
								</ul>
								<p class="u-text u-text-small"> {{ 'earnedBadgeAndBadgeDetailPage.thisIssuerIsPartOfAVerifiedOrganization' | translate }}.</p>
								</div>
							</div>
						</bg-popup-menu>
					</div>
					<div class="topbar-x-buttons">
						<div style="grid-template-columns: max-content max-content max-content;" class="l-primarymore">
							<a class="button issuer-public-banner-button-icon" href="mailto:{{ issuer.email }}">	<svg icon="icon_email"></svg></a>
							<a class="button issuer-public-banner-button-icon" target="_blank" [href]="issuer.url">  <svg style="margin-right: 4px" icon="icon_external_link"></svg> Visit Website</a>
							<img alt="Verified Issuer" class="emptysection-x-image verified-logo"
							[src]="verifiedSrc" [bgPopupMenuTrigger]="issuerVerified">
							<!-- <button class="buttonicon button-light buttonicon-secondary" id="actionstrigger"
							[bgPopupMenuTrigger]="moreMenu">
								<svg icon="icon_more"></svg>
								<span class="visuallyhidden"
								>More</span></button>
							<bg-popup-menu #moreMenu>
								<a class="menuitem" target="_blank"
								[href]="rawJsonUrl"
								><svg icon="icon_external_link"></svg>View JSON</a>
								<a class="menuitem" target="_blank"
								   [href]="issuer.sourceUrl"
								   *ngIf="issuer.sourceUrl"
								><svg icon="icon_external_link"></svg>View Original</a>
							</bg-popup-menu> -->
						</div>
					</div>
				</div>
			</div>
		</header>
		<div class="l-containerxaxis l-containeryaxis">
			<div *ngIf="badgeClasses && badgeClasses.length > 0">
				<header class=" u-margin-top1x">
					<h3 class="u-text-h3-bold u-text-dark2"
					>
					{{ badgeClasses.length | i18nPlural: plural['badge'] }}
				</h3></header>
				<!-- <table class="datatable datatable-roundheaders datatable-singlecolumn datatable-verticalalignmiddle u-margin-top2x">
					<thead class="datatable-x-head">
						<tr class="datatable-x-header">
							<th class="datatable-x-cell" scope="col">Badge</th>
						</tr>
					</thead>
					<tbody class="datatable-x-body">
						<tr class="datatable-x-row"
							*ngFor="let badgeClass of badgeClasses">
							<th class="datatable-x-cell" scope="row">
								<div class="l-flex l-flex-aligncenter l-flex-1x">
									<img class="l-flex-x-shrink0 badge-image badgeimage-small"
									     [src]="badgeClass.image"
									     [alt]="badgeClass.name"
									     width="40">
									<a class="u-text u-text-breakword"
									   [routerLink]="routerLinkForUrl(badgeClass.hostedUrl || badgeClass.id)"
									>{{ badgeClass.name }}</a>
								</div>
							</th>
						</tr>
					</tbody>
				</table> -->

		<section
			class="l-containerxaxis l-containeryaxis l-responsivelist">
			<div class="l-grid l-grid-medium">
				<a class="issuer-publicbadgecard" *ngFor="let badgeClass of badgeClasses" [routerLink]="routerLinkForUrl(badgeClass.hostedUrl || badgeClass.id)">

						<div class="issuercard-x-image">
							<img [loaded-src]="badgeClass.image" [loading-src]="issuerPlaceholderSrc" [error-src]="issuerPlaceholderSrc" alt="{{ badgeClass.name }} avatar">
						</div>
						<div class="issuercard-x-title">
							<a class="u-text u-text-breakword" [routerLink]="routerLinkForUrl(badgeClass.hostedUrl || badgeClass.id)"
											>{{ badgeClass.name }}</a>
						</div>
				</a>
			</div>
		</section>

				<!--
				
				TO DO: Add API support for pagination and implement the following pattern

				<div class="u-margin-yaxis4x">
					<nav class="pagination">
					    <h3 class="visuallyhidden"
					    >Pagination</h3>
					    <div class="pagination-x-pages">
					        <a class="page pagination-x-previous page-is-disabled" href="#" disabled>Previous</a>
					        <a class="page page-is-active" href="#">1</a>
					        <a class="page" href="#">2</a>
					        <a class="page" href="#">3</a>
					        <a class="page" href="#">4</a>
					        <a class="page" href="#">5</a>
					        <a class="page" href="#">6</a>
					        <a class="page" href="#">7</a>
					        <a class="page" href="#">8</a>
					        <a class="page" href="#">9</a>
					        <p class="page page-hellip">&hellip;</p>
					        <a class="page" href="#">200</a>
					    </div>
					    <a class="page" href="#">Next</a>
					</nav>
				</div>
				-->
			</div>
		</div>
	</main>
</ng-template>
